
import { useTranslation } from "react-i18next";
import Navbar from "@/components/Navbar";
import HeroSection from "@/components/HeroSection";
import FeaturedTherapists from "@/components/FeaturedTherapists";
import AIToolsSection from "@/components/AIToolsSection";
import PartnerOrganizations from "@/components/PartnerOrganizations";
import Testimonials from "@/components/Testimonials";
import PortalButtons from "@/components/PortalButtons";
import Footer from "@/components/Footer";
import WaveDivider from "@/components/ui/WaveDivider";
import { useFeaturedPractitioners } from "@/hooks/useFeaturedPractitioners";
import { OrganizationSEO } from "@/components/seo/OrganizationSEO";

const Index = () => {
  const { t } = useTranslation('home');
  const { practitioners, loading, error } = useFeaturedPractitioners();

  return (
    <div className="min-h-screen flex flex-col">
      <OrganizationSEO />
      <Navbar />
      <main className="flex-grow">
        <HeroSection />
        
        <WaveDivider fromColor="#FDE68A" toColor="#FFFFFF" />
        
        {loading ? (
          <section className="py-12 bg-white">
            <div className="container mx-auto px-4">
              <h2 className="text-3xl font-serif font-medium text-earth-900 mb-8 text-center">
                {t('featuredPractitionersTitle')}
              </h2>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                {[1, 2, 3].map((i) => (
                  <div
                    key={i}
                    className="h-48 bg-gray-200 rounded animate-pulse"
                  ></div>
                ))}
              </div>
            </div>
          </section>
        ) : error ? (
          <section className="py-12 bg-white">
            <div className="container mx-auto px-4">
              <h2 className="text-3xl font-serif font-medium text-earth-900 mb-8 text-center">
                {t('featuredPractitionersTitle')}
              </h2>
              <div className="text-center text-earth-600">
                <p>{t('loadError')}</p>
              </div>
            </div>
          </section>
        ) : (
          <FeaturedTherapists therapists={practitioners} />
        )}

        <WaveDivider fromColor="#FFFFFF" toColor="#FEF3C7" />
        <AIToolsSection />

        <WaveDivider fromColor="#FEF3C7" toColor="#FFFFFF" />
        <PartnerOrganizations />

        <WaveDivider fromColor="#FFFFFF" toColor="#FEF3C7" />
        <Testimonials />

        <WaveDivider fromColor="#FEF3C7" toColor="#FFFFFF" />
        <PortalButtons />
      </main>
      <Footer />
    </div>
  );
};

export default Index;
